module.exports = __webpack_public_path__ + "70d0d90f5e323ea2a6a7fdf85174bf87.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/skiis-s.png
// module id = 2445
// module chunks = 0